export const SET_SEARCH = "SET_SEARCH";
export const RESET_SEARCH = "RESET_SEARCH";
export const SET_PRESERVE_SEARCH = "SET_PRESERVE_SEARCH";
export const RESET_ALL_PRESERVE_SEARCH = "RESET_ALL_PRESERVE_SEARCH";